import { render, staticRenderFns } from "./EventosForm.vue?vue&type=template&id=64e9068c&scoped=true"
import script from "./EventosForm.vue?vue&type=script&lang=js"
export * from "./EventosForm.vue?vue&type=script&lang=js"
import style0 from "./EventosForm.vue?vue&type=style&index=0&id=64e9068c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e9068c",
  null
  
)

export default component.exports